/* DinoStudio — collection page: filter + sort over server-rendered cards. */
(function () {
  'use strict';
  var grid = document.getElementById('grid');
  if (!grid) return;
  var countEl = document.getElementById('count');
  var cards = [].slice.call(grid.querySelectorAll('.card'));
  var state = { filter: 'all', sort: 'featured' };

  function matches(card, f) {
    if (f === 'all') return true;
    if (f === 'bestsellers') return (card.getAttribute('data-badge') || '') === 'Bestseller';
    if (f === 'new') return card.getAttribute('data-new') === '1';
    return true;
  }

  function num(card, attr) { return parseFloat(card.getAttribute(attr)) || 0; }

  function sorted(list, mode) {
    var out = list.slice();
    if (mode === 'price-asc') out.sort(function (a, b) { return num(a, 'data-price') - num(b, 'data-price'); });
    else if (mode === 'price-desc') out.sort(function (a, b) { return num(b, 'data-price') - num(a, 'data-price'); });
    else if (mode === 'name') out.sort(function (a, b) { return (a.getAttribute('data-name') || '').localeCompare(b.getAttribute('data-name') || ''); });
    else if (mode === 'new') out.sort(function (a, b) {
      return (num(b, 'data-new') - num(a, 'data-new')) || (num(a, 'data-order') - num(b, 'data-order'));
    });
    else out.sort(function (a, b) { return num(a, 'data-order') - num(b, 'data-order'); }); // featured
    return out;
  }

  function apply() {
    var visible = cards.filter(function (c) { return matches(c, state.filter); });
    var ordered = sorted(visible, state.sort);
    // hide all, then re-append visible in order
    cards.forEach(function (c) { c.style.display = 'none'; });
    ordered.forEach(function (c) { c.style.display = ''; grid.appendChild(c); });
    if (countEl) countEl.textContent = ordered.length + (ordered.length === 1 ? ' piece' : ' pieces');
  }

  function init() {
    apply();
    var chips = document.querySelectorAll('.filters .chip');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        state.filter = chip.textContent.trim().toLowerCase();
        apply();
      });
    });
    var sortSel = document.getElementById('sort');
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
